/* Keep the native media gallery (variant changes, video, lightbox and announcements). */
if (!window.productEditorialInitialized) {
  window.productEditorialInitialized = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-editorial-step]');
    if (!button || button.disabled) return;
    const gallery = button.closest('media-gallery');
    const media = [...gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]')];
    if (media.length < 2) return;
    const selectedThumbnail = gallery.querySelector('.thumbnail-list [data-target]:has([aria-current="true"])');
    const requestedMediaId = gallery.requestedMediaId || gallery.dataset.activeMediaId;
    const current = media.findIndex((item) => requestedMediaId
      ? item.dataset.mediaId === requestedMediaId
      : selectedThumbnail ? item.dataset.mediaId === selectedThumbnail.dataset.target : item.classList.contains('is-active'));
    const target = Math.max(current, 0) + Number(button.dataset.editorialStep);
    if (gallery.dataset.loopMedia !== 'true' && (target < 0 || target >= media.length)) return;
    const next = (target + media.length) % media.length;
    gallery.setActiveMedia(media[next].dataset.mediaId, false, { preservePageScroll: true });
  });

  const organizePromotions = (section) => {
    if (section.dataset.promotionsObserved) return;
    const slot = section.querySelector('[data-product-extras]');
    const bundleSlot = section.querySelector('[data-product-bundles]');
    if (!slot) return;
    section.dataset.promotionsObserved = 'true';
    let scheduled = false;
    const movePromotions = () => {
      scheduled = false;
      if (bundleSlot) {
        section.querySelectorAll('adoric-bundle-mark-one').forEach((element) => {
          if (element.parentElement !== bundleSlot) bundleSlot.append(element);
        });
      }
      section.querySelectorAll('.product-editorial__buy .honeypop-pp, .product-editorial__buy .free_shipping_card').forEach((element) => {
        if (element.matches('.honeypop-pp')) slot.prepend(element);
        else slot.append(element);
      });
      const pickup = section.querySelector('.product-editorial__buy pickup-availability[available]');
      if (pickup) slot.after(pickup);
    };
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(movePromotions);
    }).observe(section, { childList: true, subtree: true });
    movePromotions();
  };
  const initializePurchaseAvailability = (section) => {
    if (section.dataset.purchaseAvailabilityObserved) return;
    section.dataset.purchaseAvailabilityObserved = 'true';
    const selector = '.product-form__quantity .quantity, [data-product-bundles], .product-editorial__buy .product-form__buttons';
    const lockedChildren = new Set();
    const originalAria = new Map();
    let scheduled = false;
    const sync = () => {
      scheduled = false;
      const price = section.querySelector('[id^="price-"]');
      const submit = section.querySelector('.product-form__submit');
      const soldOutText = window.variantStrings?.soldOut;
      const blocked = !!price?.querySelector('.price--sold-out') || !!price?.classList.contains('hidden') ||
        !!(submit?.disabled && soldOutText && submit.querySelector('span')?.textContent.trim() === soldOutText);
      section.classList.toggle('product-editorial--sold-out', blocked);
      if (!blocked) {
        lockedChildren.forEach((child) => { child.inert = false; });
        lockedChildren.clear();
      }
      section.querySelectorAll(selector).forEach((group) => {
        if (blocked) {
          if (!originalAria.has(group)) originalAria.set(group, group.getAttribute('aria-disabled'));
          if (!group.classList.contains('product-editorial__purchase-disabled')) group.classList.add('product-editorial__purchase-disabled');
          group.setAttribute('aria-disabled', 'true');
          [...group.children].forEach((child) => {
            if (!child.inert) { lockedChildren.add(child); child.inert = true; }
          });
        } else if (originalAria.has(group)) {
          group.classList.remove('product-editorial__purchase-disabled');
          const previous = originalAria.get(group);
          if (previous === null) group.removeAttribute('aria-disabled');
          else group.setAttribute('aria-disabled', previous);
          originalAria.delete(group);
        }
      });
    };
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(sync);
    }).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'value'] });
    ['click', 'pointerdown', 'keydown', 'submit'].forEach((type) => {
      section.addEventListener(type, (event) => {
        if (!section.classList.contains('product-editorial--sold-out')) return;
        const target = event.target instanceof Element ? event.target : null;
        if (target?.closest('.product-editorial__purchase-disabled') ||
            (type === 'submit' && target?.matches('form[action*="/cart/add"]'))) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
    });
    sync();
  };
  const initializeSection = (section) => {
    organizePromotions(section);
    initializePurchaseAvailability(section);
  };
  document.querySelectorAll('.product-editorial').forEach(initializeSection);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.product-editorial').forEach(initializeSection));
}
